export default "__VITE_ASSET__DuQ5fTZo__"